import { Helpers } from '@app/shared/helpers';
import { BaseModel, BaseModelInterface } from '@app/abstracts';
import { User, UserInterface } from '../user/user';
import { Formation, FormationInterface } from '../formation/formation';
import {
	DocumentAdministrative,
	DocumentAdministrativeInterface,
} from '../document-administrative/document-administrative';
export interface AttestationFinDeFormationInterface extends BaseModelInterface {
	created_at: number | Date;
	stagiaire: string | User | UserInterface;
	formation: string | Formation | FormationInterface;
	document: string | DocumentAdministrative | DocumentAdministrativeInterface;
}
export interface AttestationFinDeFormationPayload {
	stagiaire: string | User | UserInterface;
	formation: string | Formation | FormationInterface;
	document: string | DocumentAdministrative | DocumentAdministrativeInterface;
}
type AttestationFinDeFormationPayloadKey =
	keyof AttestationFinDeFormationPayload;
export class AttestationFinDeFormation extends BaseModel<
	AttestationFinDeFormationInterface,
	AttestationFinDeFormationPayload
> {
	/** Short function to get label of instance */
	getLabel(): string {
		return this.props._id;
	}
	/** Denotes if the instance of stagiaire has been populated */
	stagiaireExists(): boolean {
		return (
			!!this.props &&
			this.props.stagiaire instanceof User &&
			this.props.stagiaire.exists()
		);
	}
	/** Denotes if the instance of formation has been populated */
	formationExists(): boolean {
		return (
			!!this.props &&
			this.props.formation instanceof Formation &&
			this.props.formation.exists()
		);
	}
	/** Denotes if the instance of document has been populated */
	documentExists(): boolean {
		return (
			!!this.props &&
			this.props.document instanceof DocumentAdministrative &&
			this.props.document.exists()
		);
	}
	/** Populate the current instance from an object */
	fromObject(object: AttestationFinDeFormationInterface): void {
		this.props = Object.assign({}, object);
		this.props.created_at = Helpers.convertToDate(this.props.created_at);
		if (typeof this.props.stagiaire === 'object') {
			this.props.stagiaire = new User(
				<UserInterface>this.props.stagiaire
			);
		}
		if (typeof this.props.formation === 'object') {
			this.props.formation = new Formation(
				<FormationInterface>this.props.formation
			);
		}
		if (typeof this.props.document === 'object') {
			this.props.document = new DocumentAdministrative(
				<DocumentAdministrativeInterface>this.props.document
			);
		}
		this.next();
	}
	/** Convert the current instance to an object */
	toObject(): AttestationFinDeFormationInterface {
		const props = Object.assign({}, this.props);
		props.created_at = Helpers.convertToTimestamp(props.created_at);
		if (props.stagiaire instanceof User) {
			props.stagiaire = props.stagiaire.toObject();
		}
		if (props.formation instanceof Formation) {
			props.formation = props.formation.toObject();
		}
		if (props.document instanceof DocumentAdministrative) {
			props.document = props.document.toObject();
		}
		return props;
	}
	/** Convert an instance to an object to be sent to the API */
	toPayload(): AttestationFinDeFormationPayload {
		const raw = this.toObject();
		const allowed = this.allowedKeys();
		const payload = Object.keys(raw)
			.filter((key) => allowed.includes(<any>key))
			.reduce((o, k) => {
				o[k] = raw[k];
				return o;
			}, {} as AttestationFinDeFormationInterface);
		payload.stagiaire = payload.stagiaire
			? this.extractId(payload.stagiaire)
			: null;
		payload.formation = payload.formation
			? this.extractId(payload.formation)
			: null;
		payload.document = payload.document
			? this.extractId(payload.document)
			: null;
		return payload as AttestationFinDeFormationPayload;
	}
	/** List allowed keys to be sent to the API */
	protected allowedKeys(): AttestationFinDeFormationPayloadKey[] {
		return ['stagiaire', 'formation', 'document'];
	}
}
